var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_973_5856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_973_5856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17853 21.7615C3.62241 21.7615 3.14633 21.5549 2.7503 21.1416C2.35427 20.7284 2.15625 20.2317 2.15625 19.6514V6.99083C2.15625 6.41055 2.35427 5.9138 2.7503 5.50058C3.14633 5.08735 3.62241 4.88074 4.17853 4.88074H20.3568C20.9129 4.88074 21.389 5.08735 21.785 5.50058C22.1811 5.9138 22.3791 6.41055 22.3791 6.99083V13.3211H4.17853V19.6514H14.29V21.7615H4.17853ZM4.17853 9.10092H20.3568V6.99083H4.17853V9.10092ZM19.3457 23.8716V20.7064H16.3122V18.5963H19.3457V15.4312H21.3679V18.5963H24.4014V20.7064H21.3679V23.8716H19.3457Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/add_card.5fb50b84e0120d5d5f14af454dadeadc.svg";
export { ForwardRef as ReactComponent };